import { render } from "./StudebookStatusDetail.vue?vue&type=template&id=27bd57ab"
import script from "./StudebookStatusDetail.vue?vue&type=script&lang=js"
export * from "./StudebookStatusDetail.vue?vue&type=script&lang=js"

import "./StudebookStatusDetail.vue?vue&type=style&index=0&id=27bd57ab&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__